<template>
  <div class="addthis_inline_share_toolbox"></div>
</template>
<script>
export default {
  mounted() {
    if (window.addthis && window.addthis.layers.refresh) {
      window.addthis.layers.refresh()
    }
  }
}
</script>
